import { FC } from "react";
import { Header } from "../parts/Header";

export const JoinPage: FC = () => {
  return <div>
    <Header></Header>
    <div>
      <img src="/images/top-04.jpg" style={{ width: '100%' }}></img>
    </div>

    <div className="margin-auto px-4 box-border" style={{ width: '720px', maxWidth: '100%' }}>

      <div className="mt-12 mb-12">
        <div className="sub-title">募集対象</div>
        <div>
          現在バドミントン歴 6年以上の方のみを募集しております。ご注意ください。
        </div>

        <div className="mb-4">
          サークルのレベル感については以下の練習の動画が参考になるかと思います。
        </div>

        <div className="mt-4">
          <div className="bg-black" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, borderRadius: '12px', overflow: 'hidden' }}>
            <iframe
              src="https://www.youtube.com/embed/GDt7huQlMHs"
              title="紹介動画"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              frameBorder={0}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </div>

      <div className="mt-12 mb-12">
        <div className="sub-title">禁止事項</div>
        <div>・出会い系目的、他サークル等への引き抜きを目的とした参加</div>
        <div>・宗教、政治関係の案内や勧誘</div>
      </div>

      <div className="mt-2 mb-24">
        <div className="margin-auto" style={{ maxWidth: '360px' }}>
          <a
            href="/line"
            className="hover-button"
            style={{
              display: 'block',
              textDecoration: 'none',
              textAlign: 'center',
              padding: '12px 20px',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              backgroundColor: '#f1f5f9',
              color: '#334155',
              fontWeight: 600,
              boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
            }}
            aria-label="初参加の申し込みフォームへ"
          >
            初参加の申し込みはこちらから
          </a>
        </div>
      </div>

    </div>
  </div>
}
